var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97559 0.000362923C8.81566 0.00582418 8.66168 0.0622851 8.53613 0.161496L1.42969 5.76013C0.527739 6.47094 0 7.55712 0 8.70544V18.2504C0 18.9322 0.568203 19.5004 1.25 19.5004H6.25C6.9318 19.5004 7.5 18.9322 7.5 18.2504V13.2504C7.5 13.1028 7.60248 13.0004 7.75 13.0004H10.25C10.3975 13.0004 10.5 13.1028 10.5 13.2504V18.2504C10.5 18.9322 11.0682 19.5004 11.75 19.5004H16.75C17.4318 19.5004 18 18.9322 18 18.2504V8.70544C18 7.55712 17.4723 6.47094 16.5703 5.76013L9.46387 0.161496C9.32518 0.0519334 9.15225 -0.00513271 8.97559 0.000362923ZM9 1.70544L15.6426 6.93884C16.1846 7.36602 16.5 8.01577 16.5 8.70544V18.0004H12V13.2504C12 12.2929 11.2075 11.5004 10.25 11.5004H7.75C6.79252 11.5004 6 12.2929 6 13.2504V18.0004H1.5V8.70544C1.5 8.01577 1.81537 7.36602 2.35742 6.93884L9 1.70544Z",
    fill: "#002752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.39ca3c8dd30625d80f69065dbfaa4402.svg";
export { ForwardRef as ReactComponent };